var map = {
	".": 9028,
	"./": 9028,
	"./About": 8549,
	"./About.js": 8549,
	"./App": 4111,
	"./App.js": 4111,
	"./BadLink": 8115,
	"./BadLink.js": 8115,
	"./CardTag": 2322,
	"./CardTag.js": 2322,
	"./DescriptionParagraph": 6010,
	"./DescriptionParagraph.js": 6010,
	"./ExperiencePage": 5001,
	"./ExperiencePage.js": 5001,
	"./Header": 9339,
	"./Header.js": 9339,
	"./Layout": 5208,
	"./Layout.js": 5208,
	"./PageTag": 9981,
	"./PageTag.js": 9981,
	"./ProjectCard": 8671,
	"./ProjectCard.js": 8671,
	"./ProjectPage": 2050,
	"./ProjectPage.js": 2050,
	"./assets/fonts/Inter-VariableFont_slnt,wght.ttf": 2745,
	"./assets/images/WSA-logo.png": 8706,
	"./assets/images/base-interns.PNG": 5563,
	"./assets/images/base-logo.svg": 4748,
	"./assets/images/block-m.png": 6226,
	"./assets/images/debate-clipart.webp": 5970,
	"./assets/images/debate-stats-table.png": 5013,
	"./assets/images/hackathon.png": 3012,
	"./assets/images/headshot.jpg": 509,
	"./assets/images/march-madness-logo.png": 428,
	"./assets/images/march-madness-predictor-bracket.png": 3042,
	"./assets/images/march-madness-scorecard.png": 153,
	"./assets/images/nutristat-score-graphic.png": 1501,
	"./assets/images/nutrition-clipart.png": 8385,
	"./assets/images/prepack-poster.jpg": 1329,
	"./assets/images/pure-escape-room.jpg": 1805,
	"./assets/images/pure-flashblade.png": 4808,
	"./assets/images/pure-logo.svg": 7515,
	"./assets/images/pytorch-logo.svg": 2280,
	"./assets/images/qiskit-logo.png": 8746,
	"./assets/images/quantum-clipart.png": 3370,
	"./assets/images/quantum-logo.png": 6198,
	"./assets/images/react-logo.png": 7976,
	"./assets/images/wilson-connected-football.png": 8255,
	"./assets/images/wilson-hq.jpg": 8835,
	"./assets/images/wilson-logo.png": 7183,
	"./index": 9028,
	"./index.js": 9028,
	"./styles/about.css": 8387,
	"./styles/experience.css": 8670,
	"./styles/header.css": 4201,
	"./styles/index.css": 9536,
	"./styles/project.css": 8851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1407;